import CryptoJS from "crypto-js";
let origin = window.location.origin;

if (origin.includes("localhost")) {
    origin = origin.replace(":1234", ":3000");
}

origin = origin.replace("http:", "ws:");
origin = origin.replace("https:", "wss:");
const WSUrl = origin;

class SocketHelper {
    constructor() {
        this.websocketConnections = {
            public: {},
            private: {},
        };
        this.callbacks = {};
        this.publicWebsocketConnected = false;
        this.privateWebsocketConnected = false;
    }

    createPublicConnection(connectionId, onConnection) {
        try {
            if (this.websocketConnections.public[connectionId]) {
                return this.websocketConnections.public[connectionId];
            }

            this.websocketConnections.public[connectionId] = new WebSocket(
                WSUrl + "/websockets?nonce=" + connectionId
            );

            const websocket = this.websocketConnections.public[connectionId];
            this.websocketConnections.public[connectionId].connectionId =
                connectionId;

            websocket.onmessage = (event) => {
                try {
                    if (event.data) {
                        if (event.data === "pong") {
                            if (onConnection) onConnection("pong");
                            return;
                        }

                        if (event.data === "CLOSING_CONNECTION") {
                            this.websocketConnections.public[
                                event.target.connectionId
                            ].close();
                            delete this.websocketConnections.public[
                                event.target.connectionId
                            ];
                            return;
                        }

                        const decoded = this.decode(
                            event.data,
                            connectionId.substring(0, 32)
                        );

                        const json = JSON.parse(decoded);

                        if (!json || !json.serviceName || !json.requestId) {
                            return;
                        }

                        const { serviceName, response, requestId } = json;

                        if (
                            !this.callbacks[serviceName] ||
                            !this.callbacks[serviceName][requestId]
                        )
                            return;

                        this.callbacks[serviceName][requestId](response);
                        delete this.callbacks[serviceName][requestId];
                    }
                } catch (e) {
                    console.log(e);
                }
            };

            websocket.onerror = (event) => {
                console.log(event);
            };

            websocket.onclose = () => {
                delete this.websocketConnections.public[connectionId];
                this.setPublicConnected(false);
            };

            return this.websocketConnections.public[connectionId];
        } catch (error) {
            console.log(error);
            return { error: error.message };
        }
    }

    createPrivateConnection(connectionId, onConnection) {
        try {
            if (this.websocketConnections.private[connectionId]) {
                return this.websocketConnections.private[connectionId];
            }

            this.websocketConnections.private[connectionId] = new WebSocket(
                WSUrl + "/websockets?nonce=" + connectionId
            );
            this.websocketConnections.private[connectionId].connectionId =
                connectionId;

            const websocket = this.websocketConnections.private[connectionId];

            websocket.onmessage = (event) => {
                try {
                    // message finishing handshake between client and server
                    if (event.data === "pong") {
                        if (onConnection) onConnection("pong");
                        return;
                    }

                    // server is forcing connection to close
                    // clear out the cached connection and close connection
                    if (event.data === "CLOSING_CONNECTION") {
                        this.websocketConnections.public[
                            event.target.connectionId
                        ].close();
                        delete this.websocketConnections.private[
                            event.target.connectionId
                        ];
                        return;
                    }

                    // decodes REST API response data and sends it through
                    // the response callback function in middleware controller
                    if (event.data) {
                        const decoded = this.decode(
                            event.data,
                            connectionId.substring(0, 32)
                        );

                        const json = JSON.parse(decoded);

                        if (!json || !json.serviceName || !json.requestId) {
                            return;
                        }

                        const { serviceName, response, requestId } = json;

                        if (
                            !this.callbacks[serviceName] ||
                            !this.callbacks[serviceName][requestId]
                        )
                            return;

                        this.callbacks[serviceName][requestId](response);
                        // clean up callbacks cache or else memory leak
                        delete this.callbacks[serviceName][requestId];
                    }
                } catch (e) {
                    console.log(e);
                }
            };

            websocket.onerror = (event) => {
                console.log(event);
            };

            // clean up cache on disconnection
            websocket.onclose = () => {
                delete this.websocketConnections.private[connectionId];
                this.setPrivateConnected(false);
            };

            return this.websocketConnections.private[connectionId];
        } catch (error) {
            console.log(error);
        }
    }

    checkPublicConnected() {
        return this.publicWebsocketConnected;
    }

    checkPrivateConnected() {
        return this.privateWebsocketConnected;
    }

    setPublicConnected(flag) {
        this.publicWebsocketConnected = flag;
    }

    setPrivateConnected(flag) {
        this.privateWebsocketConnected = flag;
    }

    // caches the enqueued Axios request until established connection
    onResponse(serviceName, id, callback) {
        try {
            if (!serviceName || !callback || !id) return;

            if (!this.callbacks[serviceName]) {
                this.callbacks[serviceName] = {};
            }

            this.callbacks[serviceName][id] = callback;
        } catch (e) {
            console.log(e);
        }
    }

    decode(input, key) {
        try {
            var keys = CryptoJS.enc.Utf8.parse(key);
            let base64 = CryptoJS.enc.Base64.parse(input);
            let src = CryptoJS.enc.Base64.stringify(base64);
            var decrypt = CryptoJS.AES.decrypt(src, keys, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            });

            return decrypt.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.log(e);
            return input;
        }
    }
}

export default new SocketHelper();
